angular.module('mercury.modules.stock.xero')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.XeroPurchaseOrder', {
    url: '/xero/purchaseorder?:exportData&:report',
    controller: 'StockXeroPurchaseorderCtrl',
    templateUrl: 'modules/stock/xero/purchaseorder.tpl.html',
    data: {
      menuLinkState: 'Stock.ReportSupplier'
    }
  });
}]);
